/**
 * Bidding-portal load references often include a letter prefix (e.g. carrierpoint DSM63115152).
 * Automation expects the numeric core. Uses the first whitespace-separated token, then strips non-digits.
 */
export function normalizePortalLoadIdToNumericCore(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) {
    return '';
  }

  const firstToken = (trimmed.split(/\s+/)[0] ?? trimmed).trim();
  return firstToken.replace(/\D/g, '');
}
